module.exports = __webpack_public_path__ + "static/img/back.7201098e.png";